<div style="aspect-ratio: 1920/1080">
    <swiper-container class="viewer-slider" init="false" navigation="true" #viewerSwiperRef>
        @if(sliderInitialized()){ @for (item of slides(); track $index) {
        <swiper-slide class="slide relative">
            <img placeholder priority [ngSrc]="item.imgSrc" width="1920" height="1080" alt="{{ item.name }}" style="object-position: center; object-fit: contain" />

            @if (item.videoSrc) {
            <video playsinline autoplay loop muted class="absolute inset-0 w-full h-full object-cover object-center" preload="auto" loading="lazy">
                <source [src]="item.videoSrc" type="video/mp4" />
                Your browser does not support the video tag.
            </video>
            <div class="absolute inset-0 bg-black opacity-50"></div>
            }
            <!-- @if (item.body?.length > 0) {
            <div class="absolute inset-0 bg-black opacity-50"></div>
            <div class="info absolute z-10">
                @if (item.body?.length > 0) {
                <p style="margin: 0" [innerHTML]="item.body | html"></p>
                }
            </div>
            } -->
        </swiper-slide>
        } }
    </swiper-container>
</div>

<div style="padding-top: 0px; padding-bottom: 0px; background-color: hsl(0deg 0% 0%); padding-block-end: 2em">
    <div class="container about">
        <div class="row card reverse">
            <div class="image-wrapper">
                <img priority placeholder width="100" height="100" ngSrc="/assets/idrisesen.webp" alt="idris esen" />
            </div>
            <div class="content" style="padding: 1rem">
                <h3 class="title" i18n="Idris Esen">Idris Esen</h3>
                <p i18n>
                    A passionate artist who has devoted over two decades to the realms of artistry, direction, and photography. My journey through the world of art continues to
                    captivate and inspire me every single day.
                </p>
                <a class="button button-primary" routerLink="/about-me">
                    <span #aboutMeBtn i18n="about-me">About Me</span>
                </a>
            </div>
        </div>
    </div>
</div>

<div class="section">
    <div class="flex row main-fields-boxes">
        @for (group of galleryBoxes() | keyvalue; track group.key) {
        <iea-home-page-gallery-box class="box" [category]="types.get(group.key)" [artBoards]="group.value"></iea-home-page-gallery-box>
        }
    </div>
</div>

<div style="padding-top: 0px; padding-bottom: 0px; padding: 2em 0">
    <div class="container about article-list">
        <h2 style="text-align: center; margin-bottom: 1rem" i18n="Articles">Articles</h2>
        <blogs-list [blogs]="blogs()" [cardDirection]="'hor'"></blogs-list>
    </div>
</div>
